/**
 * Device Fingerprinting for Trusted Device Authentication
 */

/**
 * Generate device fingerprint
 */
export async function generateDeviceFingerprint() {
  const fingerprint = {
    userAgent: navigator.userAgent,
    language: navigator.language,
    platform: navigator.platform,
    screenResolution: `${screen.width}x${screen.height}`,
    colorDepth: screen.colorDepth,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    hardwareConcurrency: navigator.hardwareConcurrency,
    deviceMemory: navigator.deviceMemory || 'unknown',
    // Canvas fingerprint for additional uniqueness
    canvas: await getCanvasFingerprint()
  };

  return fingerprint;
}

/**
 * Generate canvas fingerprint
 */
async function getCanvasFingerprint() {
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    
    if (!ctx) return 'unsupported';

    canvas.width = 200;
    canvas.height = 50;

    // Draw text with specific styling
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.textBaseline = 'alphabetic';
    ctx.fillStyle = '#f60';
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = '#069';
    ctx.fillText('Device ID', 2, 15);
    ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
    ctx.fillText('Device ID', 4, 17);

    // Get data URL and hash it
    const dataUrl = canvas.toDataURL();
    const hash = await simpleHash(dataUrl);
    
    return hash;
  } catch (error) {
    console.error('Canvas fingerprint error:', error);
    return 'error';
  }
}

/**
 * Simple hash function for canvas data
 */
async function simpleHash(str) {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('').substring(0, 16);
}

/**
 * Get stored device fingerprint (if previously saved)
 */
export function getStoredFingerprint() {
  try {
    const stored = localStorage.getItem('device_fingerprint');
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    return null;
  }
}

/**
 * Store device fingerprint
 */
export function storeFingerprint(fingerprint) {
  try {
    localStorage.setItem('device_fingerprint', JSON.stringify(fingerprint));
  } catch (error) {
    console.error('Failed to store fingerprint:', error);
  }
}
